var map = {
	"./abb-color.svg": 1733,
	"./afb-color.svg": 1734,
	"./afb.svg": 1735,
	"./alb-color.svg": 1736,
	"./alb.svg": 1737,
	"./amb-color.svg": 1738,
	"./amb.svg": 1739,
	"./bbbaidja-color.svg": 1740,
	"./bbbaidjaxxx-color.svg": 1741,
	"./bdinidjaxxx-color.svg": 1742,
	"./bimb-color.svg": 1743,
	"./bimb.svg": 1744,
	"./bkr-color.svg": 1745,
	"./bkr.svg": 1746,
	"./bmriidja-color.svg": 1747,
	"./bniaidja-color.svg": 1748,
	"./bninidja-color.svg": 1749,
	"./bninidjaxxx-color.svg": 1750,
	"./bpay-color.svg": 1751,
	"./brinidja002-color.svg": 1752,
	"./bsmdidjaxxx-color.svg": 1753,
	"./bsn-color.svg": 1754,
	"./bsn.svg": 1755,
	"./btanidjaxxx-color.svg": 1756,
	"./cenaidja-color.svg": 1757,
	"./cenaidjaxxx-color.svg": 1758,
	"./cimb-color.svg": 1759,
	"./cimb.svg": 1760,
	"./citi-color.svg": 1761,
	"./citi.svg": 1762,
	"./default-bank-icon-color.png": 1763,
	"./default-bank-icon.png": 1764,
	"./gxbank-color.svg": 1765,
	"./hlb-color.svg": 1766,
	"./hlb.svg": 1767,
	"./hsbc-color.svg": 1768,
	"./hsbc.svg": 1769,
	"./ibbkidjaxxx-color.svg": 1770,
	"./kwh-color.svg": 1771,
	"./kwh.svg": 1772,
	"./mbb-color.svg": 1773,
	"./mbb.svg": 1774,
	"./nispidjaxxx-color.svg": 1775,
	"./ocbc-color.svg": 1776,
	"./ocbc.svg": 1777,
	"./pbb-color.svg": 1778,
	"./pbb.svg": 1779,
	"./pinbidja-color.svg": 1780,
	"./rhb-b.svg": 1781,
	"./rhb-color-b.svg": 1782,
	"./rhb-color.svg": 1783,
	"./rhb.svg": 1784,
	"./scb-color.svg": 1785,
	"./scb.svg": 1786,
	"./tng-color.svg": 1787,
	"./uob-color.svg": 1788,
	"./uob.svg": 1789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;